module.exports = __webpack_public_path__ + "d07dfefa451ad166e1e437af4db43f59.png";